/**
 * Ruteo de la consola. El BrowserRouter lo monta `App`.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { routes } from './routes';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '@presentation/pages/Login';
import { AuthCallbackPage } from '@presentation/pages/AuthCallback';
import { ApplicationsPage } from '@presentation/pages/Applications';
import { RolesPage } from '@presentation/pages/Roles';
import { UsersPage } from '@presentation/pages/Users';
import { NotFoundPage } from '@presentation/pages/NotFound';

export function AppRouter() {
  return (
    <Routes>
      <Route path={routes.login} element={<LoginPage />} />
      <Route path={routes.authCallback} element={<AuthCallbackPage />} />

      <Route path={routes.home} element={<Navigate to={routes.users} replace />} />

      <Route
        path={routes.applications}
        element={
          <ProtectedRoute>
            <ApplicationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={routes.roles}
        element={
          <ProtectedRoute>
            <RolesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path={routes.users}
        element={
          <ProtectedRoute>
            <UsersPage />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
